




















































import ThgQuoteWorkitemRegistrationCard from "@/components/thg/ThgQuoteWorkitemRegistrationCard.vue";
import { requiredRule } from "@/lib/rules/requiredRule";
import { deepCopy } from "@/lib/utility/deep-copy";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { PartnerEntity } from "@/models/partnerEntity";
import { PartnerModule } from "@/store/modules/partner";
import { ThgPortalModule } from "@/store/modules/thg.portal.store";
import { Component } from "vue-property-decorator";
import { ThgTransferThgDtoGen } from "@/services/thg/v1/data-contracts";

@Component({
  components: {
    ThgQuoteWorkitemRegistrationCard
  }
})
export default class ThgQuoteTransferDialog extends DarkModeHighlightMixin {
  isLoading = false;
  dialog = false;
  valid = false;
  partner: PartnerEntity = {} as PartnerEntity;

  transferToUser = false;

  thgId = "";
  userId = "";

  title = "components.thg.ThgQuoteTransferDialog.title";
  content = "components.thg.ThgQuoteTransferDialog.content";
  btnText = "components.thg.ThgQuoteTransferDialog.btnText";

  get loading() {
    return this.isLoading;
  }

  get partners() {
    return PartnerModule.partners;
  }

  async transfer() {
    this.isLoading = true;
    let dto: ThgTransferThgDtoGen | undefined = undefined;
    try {
      if (!this.transferToUser) {
        dto = { partnerId: this.partner.id || this.partner._id };
      }
      if (this.transferToUser) {
        dto = { userId: this.userId };
      }

      if (dto) {
        const updatedThg = await ThgPortalModule.transfer(dto);
        await ThgPortalModule.getSelectedThgByPartnerID({
          thgId: updatedThg.id,
          partnerId: updatedThg.partnerId
        });
        this.$router.push({
          name: "ThgQuoteDetailView",
          params: { thgId: updatedThg.id, partnerId: updatedThg.partnerId }
        });
      }
    } catch (error) {
      this.$log.error(error);
      this.$toast.error("Fehler beim transferieren.");
    } finally {
      this.isLoading = false;
      this.dialog = false;
    }
  }

  async initialize() {
    this.isLoading = true;
    this.thgId = deepCopy(ThgPortalModule.selectedThg.id);
    this.isLoading = false;
  }

  close() {
    this.dialog = false;
  }

  /**
   * Rules
   */

  get requiredRules() {
    const rules = [];

    rules.push(requiredRule());

    return rules;
  }
}
